import * as R from "remeda";

import type {
    DataDimensionInput,
    DataDimensionValueBaseConfig,
} from "./dimension.data.value";
import {
    DataDimensionValue,
    DataDimensionValueType,
} from "./dimension.data.value";

export enum DataDimensionValueLogicFunction {
    FIRST = "first",
}

export type DataDimensionValueLogicRuleInput =
    | string
    | DataDimensionValueLogicRule;

export interface DataDimensionValueLogicRule {
    function: DataDimensionValueLogicFunction;
    args: DataDimensionValueLogicRuleInput[];
}

const DataDimensionValueLogicFunctionHandler: {
    [key in DataDimensionValueLogicFunction]: (
        rule: DataDimensionValueLogicRule,
        ...args: any[]
    ) => string;
} = {
    [DataDimensionValueLogicFunction.FIRST]: (
        rule: DataDimensionValueLogicRule,
        ...args: string[]
    ) => {
        const result = args.find((s) => R.isTruthy(s));
        if (!result) {
            return "";
        }
        return result;
    },
};

export interface DataDimensionValueLogicConfig
    extends DataDimensionValueBaseConfig {
    type: DataDimensionValueType.LOGIC;
    rule: DataDimensionValueLogicRule;
}

export class DataDimensionValueLogic extends DataDimensionValue {
    constructor(dimensionId: string, config: DataDimensionValueLogicConfig) {
        super(dimensionId, config);
        this.config = config;
    }

    type = DataDimensionValueType.LOGIC;
    config: DataDimensionValueLogicConfig;

    protected handler(input: DataDimensionInput): string {
        if (typeof input !== "object") {
            throw new Error("datasource provided must return an object");
        }
        const result = DataDimensionValueLogic.processLogicRules(
            this.config.rule,
            input,
        );
        return result;
    }

    public static processLogicRules(
        rule: DataDimensionValueLogicRule,
        input: object,
    ): string {
        const functionHandler =
            DataDimensionValueLogicFunctionHandler[rule.function];
        if (!functionHandler) {
            throw new Error("no function found");
        }

        const args: Array<string> = [];

        for (const arg of rule.args) {
            if (typeof arg === "string") {
                if (Object.keys(input).includes(arg)) {
                    args.push(input[arg]);
                } else {
                    // should make error optional based on user configuration
                    // throw new Error(`no ${arg} found in datasource`);
                    args.push("");
                }
            } else {
                args.push(this.processLogicRules(arg, input));
            }
        }

        return functionHandler(rule, ...args);
    }
}
